import { useKeycloak } from "@react-keycloak/web";
import { AxiosRequestConfig } from "axios"

import { axiosInstance } from "src/lib/axios-instance";

type APIResourceType = {
  path: string,
  method?: 'get' | 'post' | 'put' | 'delete',
  payload?: Object
}

const useApiResource = () => {
const { keycloak } = useKeycloak();

const apiResource = async ({ path, method = 'get', payload }: APIResourceType) => {

    const config: AxiosRequestConfig = {
      method,
      url: path,
      ...(payload && { data: payload }),
      headers: {
        Authorization: `Bearer ${keycloak?.token}`,
      }, 
    };
  
    const { data } = await axiosInstance(config);
    return data;
  }

  return apiResource
}

export default useApiResource